export default __webpack_public_path__ + "c87c3a04def7e5adfcdd927c0a653eb1.svg";